<template>
  <div class="message-page-container">
    <van-nav-bar style="position: fixed; top: 0; left: 0; width: 100%; background-color: transparent;color: #fff;" :title="$t('消息中心')" left-arrow @click-left="$router.back()" />
    <div style="height: 60px; flex-shrink: 0"></div>
    <div class="content">
      <div class="tab-list">
        <div @click="changType(1)" aria-selected="true" :class="type == 1 ? 'tab-item active' : 'tab-item'">
          {{  $t('公告') }}
        </div>
        <div @click="changType(2)" :class="type == 2 ? 'tab-item active' : 'tab-item'">
          {{ $t('站内信') }}
        </div>
      </div>
      <div class="tab-content">
        <div v-if="type == 1" class="tab-content-item" style="">
          <van-list :finished-text="$t('没有更多了')" :finished="true" v-if="homenoticelis.length > 0">
            <div class="msg-item" v-for="(item, index) in homenoticelis" :key="index">
              {{ item }}
            </div>
          </van-list>
          <van-divider v-else dashed :style="{ color: '#ccc', borderColor: '#ccc', padding: '20px 100px' }">{{ $t('没有更多了') }}~</van-divider>
        </div>
        <div v-if="type == 2" class="tab-content-item">
          <van-list :finished-text="$t('没有更多了')" offset="300" v-model="loading" :finished="noticeList.length == noticeListInfo.total" @load="getDatalist" v-if="noticeList.length > 0">
            <div class="notice-item" v-for="(item, index) in noticeList" :key="index">
              <div style="display: flex;justify-content: space-between;align-items: center;">
                <div class="unReadTitle">
                  {{ item.title }}
                </div>
                <div class="time">{{ item.created_at }}</div>
              </div>
              <div class="text" v-html="item.content"></div>
            </div>
          </van-list>
          <van-divider v-else dashed :style="{ color: '#ccc', borderColor: '#ccc', padding: '20px 100px' }">{{ $t('没有更多了') }}~</van-divider>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {translateText} from "../common/utils";

export default {
  name: 'message',
  data() {
    return { type: 1, noticeList: [], homenoticelis: [], noticeListInfo: {}, page: 1 };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    if (query.type) {
      that.type = query.type * 1;
    }

    that.homenotice();
    that.getDatalist();
  },
  methods: {
    changType(type) {
      let that = this;
      that.type = type;
      // if(type === 2) {
      //
      // }
    },
    async showTost(type = 0, title) {
      const message = await translateText([title]);
      this.$parent.showTost(type, message[0]);
    },
    homenotice() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/homenotice', {}).then(async (res) => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          const list = res.data
          that.homenoticelis = []
          const text = await translateText(list)
          that.homenoticelis = text
        }
        that.$parent.hideLoading();
      });
    },
    getDatalist() {
      let that = this;
      let page = that.page;
      if (page > that.noticeListInfo.last_page) {
        that.loading = false;

        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/noticeList', { page })
        .then(async (res) => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.noticeListInfo = res.data;
            const arr = res.data.data || [];
            let title_arr = [], content_arr = []
            arr.forEach(item => {
              title_arr.push(item.title)
              content_arr.push(item.content)
            })
            const text_arr = await translateText([...title_arr,'-', ...content_arr])
            const parts = text_arr.join(',').split('-').map(s => s.split(',').filter(Boolean))

            title_arr = parts[0]
            content_arr = parts[1]
            arr.forEach((item,index) => {
              item.title = title_arr[index]
              item.content = content_arr[index]
            })
            console.log(arr)
            if (page == 1) {
              that.noticeList = arr;
            } else {
              let list = JSON.parse(JSON.stringify(that.list));
              arr.forEach(el => {
                list.push(el);
              });
              that.noticeList = list;
            }
            that.page = page + 1;
          }
          that.loading = false;

          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss">
.message-page-container {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: #000;
  color: #fff;
  font-family: PingFang SC;
  background-image: url("/static/image/new/page-bg-img.png");
  background-size: cover;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    .tab-list {
      display: flex;
      align-items: center;
      background: rgba(255, 255, 255, 0.10);
      border: 0.03rem solid rgba(255, 255, 255, 0.10);
      border-radius: .21rem;
      margin: 0 .4rem;
      .tab-item {
        width: 50%;
        height: 1.07rem;
        line-height: 1.07rem;
        text-align: center;
        font-size: 0.43rem;
        border-radius: .21rem;
        &.active {
          font-weight: bold;
          background: linear-gradient(to bottom, #2E0B71, #7214D7);
        }
      }
    }
    .tab-content {
      flex: 1;
      overflow: auto;
      padding: 0 .4rem;
      .tab-content-item {
        height: 100%;
        .msg-item {
          padding: .29rem .27rem;
          background: rgba(255, 255, 255, 0.10);
          border: 0.03rem solid rgba(255, 255, 255, 0.10);
          margin-top: .27rem;
          font-size: 0.27rem;
          color: #E1E1E1;
          line-height: 0.48rem;
          border-radius: .21rem;
        }
        .notice-item {
          padding: 0.37rem;
          background: rgba(255, 255, 255, 0.10);
          border: 0.03rem solid rgba(255, 255, 255, 0.10);
          margin-top: .27rem;
          border-radius: .21rem;
          .unReadTitle {
            font-size: 0.32rem;
          }
          .time {
            font-size: 0.27rem;
            color: #8C8C8C;
          }
          .text {
            font-size: 0.27rem;
            color: #8C8C8C;
            margin-top: .11rem;
          }
        }
      }
    }
  }
  .van-nav-bar .van-icon {
    color: #fff !important;
  }
  .van-nav-bar__arrow {
    font-size: .48rem !important;
  }
  .van-nav-bar__title {
    color: #fff !important;
    font-size: 0.48rem;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/message.vue